<template>
  <div id="app">
    <component :is="$store.state.user.auth ? 'Header' : 'HeaderLogin'"></component>
    <main class="main">
      <div class="container">
        <router-view/>
      </div>
    </main>
  </div>
</template>

<style lang="scss">
  @font-face {
    font-family: 'Museo';
    src: url('../public/fonts/museo/MuseoSansCyrl_0.otf');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Museo';
    src: url('../public/fonts/museo/MuseoSansCyrl_1.otf');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Museo';
    src: url('../public/fonts/museo/MuseoSansCyrl_2.otf');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Segoe';
    src: url('../public/fonts/segoe/9404.ttf');
    font-weight: 400;
    font-style: normal;
  }

  @import "./style/var";
  @import "./style/style";

  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }

  body {
    margin: 0;
  }

  a {
    transition: all 0.3s ease;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  button {
    font: inherit;
  }

  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: $museo;
    font-weight: 300;
    font-size: 16px;
    color: $black;
  }

  .main {
    position: relative;
    display: flex;
    flex-grow: 1;
  }

</style>
<script>
  import Header from "./components/layout/Header";
  import HeaderLogin from "./components/layout/HeaderLogin";
  export default {
    components: {HeaderLogin, Header},
    metaInfo() {
      return {
        title: this.$route.meta.title
      }
    }
  }
</script>